module.exports = __webpack_public_path__ + "static/media/2-2.f3d741d8.png";